import classNames from 'classnames';
import css from './FinishManualInMoney.module.scss';
import { Img, svgSprite } from '../../../../../../../../../hybrid/wrappers';
import { navigateV2 } from '../../../../../../../../../common/utils/router';
import T from '../../../../../../../../../common/components/T';
import QRCode from 'react-qr-code';
import SingleButton from '../../../../../../../../../widgets/form/form-control-buttons/SingleButton/SingleButton';
import { useState } from 'react';
import Modal from '../../../../../../../../../widgets/modal/Modal';
import Display from '../../../../../../../../../common/components/Display';

const ModalSend = ({ closeHandler }) => {
    return (
        <Modal closeHandler={closeHandler}>
            <div className={css.modalContent}>
                <Img src='/src/img/plugs/payment_done_modal_icon.svg' alt='Done' />
                <p className={css.modalTitle}>
                    <T textName='proof_of_payment' defaultStr='Подтверждение оплаты' page='/store' />
                </p>
                <p className={css.modalText}>
                    <T
                        textName='proof_of_payment_text'
                        defaultStr='Ваша оплата на проверке. Для подтверждения оплаты необходимо предоставить копию чека на номер телефона.'
                        page='/store'
                    />
                </p>
                <div className={css.bottomblock}>
                    <p className={css.bottomPhone}>+7 707 321 21 21</p>
                    <p className={css.bottomText}>
                        <T textName='opening_hours_small' defaultStr='График работы с 10:00 до 18:00' page='/store' />
                    </p>
                </div>
            </div>
        </Modal>
    );
};

export default function FinishManualInMoney({ data, responseComisson }) {
    const [showModal, setShowModal] = useState(false);
    return (
        <>
            <div className={css.wrapper}>
                <div className={css.bg}>
                    <div className={css.content}>
                        <div onClick={() => navigateV2('/store')} className={classNames('circleButton', css.backButton)}>
                            {svgSprite('arrow-left')}
                        </div>
                        <div className={css.center}>
                            <p className={css.title}>
                                <T
                                    vars={{ orderNumber: 231 }}
                                    textName='payment_for_order_number'
                                    defaultStr='Оплата заказа #${orderNumber}'
                                    page='/store'
                                />
                            </p>
                            <div className={css.qr}>
                                <QRCode size={220} value='https://www.google.com' />
                            </div>
                            <ol className={css.qrInfo}>
                                <li>
                                    <T
                                        textName='finish_manual_order_payment_info_1'
                                        defaultStr='Отсканируйте QR-код для оплаты заказа'
                                        page='/store'
                                    />
                                </li>
                                <li>
                                    <T
                                        textName='finish_manual_order_payment_info_2'
                                        defaultStr='Укажите назначение платежа «‎За товар»'
                                        page='/store'
                                    />
                                </li>
                            </ol>
                            <div className={css.priceBlock}>
                                <div className={css.priceBlockRow}>
                                    <p className={css.priceBlockLabel}>
                                        <T textName='storeOrderBall' defaultStr='Баллов' page='/store' />:
                                    </p>
                                    <div className={css.priceBlockLineDots}></div>
                                    <p className={css.priceBlockValue}></p>
                                </div>
                                <div className={css.priceBlockRow}>
                                    <p className={css.priceBlockLabel}>
                                        <T textName='storeOrderToPayment' defaultStr='К оплате' page='/store' />:
                                    </p>
                                    <div className={css.priceBlockLineDots}></div>
                                    <p className={css.priceBlockValue}>
                                        {responseComisson
                                            ? responseComisson?.payment_amount_formatted
                                            : data?.amount_formatted ||
                                              data?.account_amount_formatted || (
                                                  <Display
                                                      type='value'
                                                      data={{
                                                          value: (!isNaN(data) && data) || '0'
                                                      }}
                                                  />
                                              )}
                                    </p>
                                </div>
                            </div>
                            <SingleButton
                                type='ok'
                                buttonText={<T textName='payed' defaultStr='Оплачено' page='/store' />}
                                customButton={{
                                    butWrapper: css.buttonPayed
                                }}
                                clickFunc={setShowModal}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {showModal ? <ModalSend closeHandler={() => setShowModal(false)} /> : null}
        </>
    );
}
